import { t, Trans } from "@lingui/macro";
import { UiTypography } from "@smp/ui";
import { FC } from "react";

import { FormTextFieldV2 } from "@/components/form/form_text_field_v2";

export interface IGeneralParamsProps {
  disabled?: boolean;
  classes?: Partial<{
    group: string;
    row: string;
  }>;
}

export const ExtraParams: FC<IGeneralParamsProps> = ({ classes, disabled }) => (
  <div className={classes?.group}>
    <div className={classes?.row}>
      <UiTypography variant="h5">
        <Trans>Your USP</Trans>
      </UiTypography>

      <div>
        <FormTextFieldV2
          fullWidth
          multiline
          variant="outlined"
          name="context.usp"
          placeholder={t`__advisor.edit_agent.form.placeholder.usp`}
          disabled={disabled}
        />
      </div>
    </div>

    <div className={classes?.row}>
      <UiTypography variant="h5">
        <Trans>How are you different from competitors?</Trans>
      </UiTypography>

      <div>
        <FormTextFieldV2
          fullWidth
          multiline
          variant="outlined"
          name="context.benefits"
          placeholder={t`__advisor.edit_agent.form.placeholder.benefits`}
          disabled={disabled}
        />
      </div>
    </div>

    <div className={classes?.row}>
      <UiTypography variant="h5">
        <Trans>Your goal</Trans>
      </UiTypography>

      <div>
        <FormTextFieldV2
          fullWidth
          multiline
          variant="outlined"
          name="context.goal"
          placeholder={t`__advisor.edit_agent.form.placeholder.goal`}
          disabled={disabled}
        />
      </div>
    </div>

    <div className={classes?.row}>
      <UiTypography variant="h5">
        <Trans>Key messages</Trans>
      </UiTypography>

      <div>
        <FormTextFieldV2
          fullWidth
          multiline
          variant="outlined"
          name="context.key_messages"
          placeholder={t`__advisor.edit_agent.form.placeholder.key_messages`}
          disabled={disabled}
        />
      </div>
    </div>

    <div className={classes?.row}>
      <UiTypography variant="h5">
        <Trans>What topics should be avoided?</Trans>
      </UiTypography>

      <div>
        <FormTextFieldV2
          fullWidth
          multiline
          variant="outlined"
          name="context.avoided_topics"
          placeholder={t`__advisor.edit_agent.form.placeholder.avoided_topics`}
          disabled={disabled}
        />
      </div>
    </div>

    <div className={classes?.row}>
      <UiTypography variant="h5">
        <Trans>Sample text to emulate the original style</Trans>
      </UiTypography>

      <div>
        <FormTextFieldV2
          fullWidth
          multiline
          variant="outlined"
          name="context.sample"
          placeholder={t`__advisor.edit_agent.form.placeholder.sample`}
          disabled={disabled}
        />
      </div>
    </div>
  </div>
);
